import find from 'lodash/find';
import Vue from 'vue';

/**
 * Used in setInitialState to find a facet in
 * the list of available facets and apply it
 * @param {object} state
 * @param {string} facetType
 * @param {number} paramValue
 */
export default (state, facetType, paramValue) => {
    const facetValues = paramValue.split(',');

    facetValues.forEach((facetValue) => {
        const foundFacet = find(
            state.availableFacets[facetType],
            (obj) => obj.key == facetValue //eslint-disable-line
        );

        if (foundFacet) {
            const facetToAdd = {
                value: foundFacet.key,
                label: foundFacet.label,
                type: facetType,
            };

            if (facetToAdd) {
                Vue.set(state.appliedFacets, state.appliedFacets.length, facetToAdd);
            }
        }
    });
};
